import { AuditEntity } from '@gooduncles/gu-app-schema';

/**
 * Firestore collection 이름에서 AuditEntity를 추론하기 위한 매핑.
 * 신규 collection은 여기 추가. 매핑 안 되는 경우 inferEntity가 fallback을 반환.
 */
export const COLLECTION_TO_ENTITY: Record<string, AuditEntity> = {
  order: 'order',

  product: 'product',
  productSnapshot: 'product',
  productGroupForCategory: 'product',
  productWeeklyPrice: 'product',
  garakMarketProductPriceTrend: 'product',
  guProductPriceTrend: 'product',
  competitorProductMapping: 'product',
  dabomFoodProduct: 'product',
  CJFreshwayProduct: 'product',
  sehyeonFnBProduct: 'product',
  foodpangProduct: 'product',

  store: 'store',
  store_search_index: 'store',
  storeIssue: 'store',
  storeSalesInfo: 'store',

  productInventory: 'inventory',
  productInventoryHistory: 'inventory',
  productSupplier: 'inventory',
  productBatchUpdateHistory: 'inventory',
  productInboundTransaction: 'inventory',
  productOutboundTransaction: 'inventory',
  inventoryIssue: 'inventory',
  productSupplierInventoryReceipt: 'inventory',
  dailyInventoryChanges: 'inventory',

  issueCase: 'issue',
  issueLiability: 'issue',
  dailyIssue: 'issue',
  issueCaseMessageLink: 'issue',

  issueTask: 'issueTask',

  invoice: 'settlement',
  invoiceDetail: 'settlement',
  settlementResult: 'settlement',
  paymentItem: 'settlement',

  deliverySpot: 'delivery',
  deliveryCourier: 'delivery',
  deliveryRouteHistory: 'delivery',
  packingInfoSnapshot: 'delivery',
  deliveryPerformance: 'delivery',
  deliveryTask: 'delivery',
  pickupTask: 'delivery',
  partnersUser: 'delivery',
  partnersVehicle: 'delivery',
  partnersDevice: 'delivery',

  user: 'user',
  hyosungCMSMember: 'user',
  device: 'user',

  config: 'config',
  purchaseOrderSectionConfig: 'config',
  orderProductAlertConf: 'config',
  commerceNotice: 'config',

  promotionSection: 'promotion',
  customPromotionSection: 'promotion',
  processCommerce: 'promotion',

  notification: 'notification',
  alimtalkMessage: 'notification',
  friendtalkMessage: 'notification',
  mobileMessage: 'notification',
  kakaoBrandMessage: 'notification',
  fcmRequest: 'notification',
  channel: 'notification',
  triggerChannelMessage: 'notification',
  noTriggerChannelMessage: 'notification',

  productSupplierPurchaseOrder: 'purchaseOrder',
};

/**
 * audit log 자동 기록에서 제외할 collection.
 * - auditLog: 자기 자신 write 시 무한 루프 방지
 * - log/logOrder/logCommerce: 시스템 로그 (운영자 행위 아님)
 */
export const SKIP_AUDIT_COLLECTIONS: ReadonlySet<string> = new Set(['auditLog', 'log', 'logOrder', 'logCommerce']);

/**
 * 매핑 미스 시 사용할 fallback entity.
 * 실제 collection 이름은 audit log의 metadata.collection에 보존된다.
 */
const FALLBACK_ENTITY: AuditEntity = 'misc';

/** collection 이름에서 AuditEntity를 추론한다. 매핑 없으면 fallback. */
export const inferEntity = (collection: string): AuditEntity => COLLECTION_TO_ENTITY[collection] ?? FALLBACK_ENTITY;

/** auto audit 로그 대상에서 제외할지 판정. */
export const shouldSkipAudit = (collection: string): boolean => SKIP_AUDIT_COLLECTIONS.has(collection);
